import { useNavigate, useParams } from "react-router-dom";
import InfoChip from "../components/common/InfoChip";
import { Severity } from "../types";
import {
  useFetchModifierOptionDetailsQuery,
  useUpdateModifierOptionMutation,
} from "../store";
import ModifierOptionForm from "../forms/ModifierOption.form";
import { showToast, ToastType } from "../utils/toast.utils";
import { modifierOptionSchema } from "../configs";

const EditModifierOptionWrapper = () => {
  const { modifierOptionId } = useParams();

  if (!modifierOptionId)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Restaurant Introuvable"
      />
    );

  return <EditModifierOption modifierOptionId={modifierOptionId} />;
};

interface EditModifierOptionProps {
  modifierOptionId: string;
}

const EditModifierOption: React.FC<EditModifierOptionProps> = ({
  modifierOptionId,
}) => {
  const [updateModifierOption, { isLoading }] =
    useUpdateModifierOptionMutation();
  const { data: modifierOptionDetails, isFetching } =
    useFetchModifierOptionDetailsQuery(modifierOptionId);
  const navigate = useNavigate();

  if (isLoading || isFetching) return <div> loading... </div>;

  if (!modifierOptionDetails)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Supplément Introuvable"
      />
    );

  return (
    <div className="w-full flex flex-col items-center p-4">
      <ModifierOptionForm
        initialValues={{
          ...modifierOptionDetails,
          price: modifierOptionDetails.price / 100,
        }}
        validationSchema={modifierOptionSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const result = await updateModifierOption({
            modifierOptionId,
            body: {
              ...values,
              price: values.price * 100,
            },
          });
          if (!result.error) {
            showToast("Supplément mis à jour", ToastType.SUCCESS);
            resetForm();
            navigate("/modifier-options");
          }
        }}
      />
    </div>
  );
};

export default EditModifierOptionWrapper;
